// @flow
import React from 'react'
import './styles.scss'

type Props = {
  slideId: string,
  isMobile: boolean,
  imgMobile: string,
  imgDesktop: string,
  captionOpen: boolean,
  captionWasOpen: boolean,
  isSliding: string,
  caption: string,
  credits: string,
  toggleCaption: any
}

const iconCaption = require('./img/caption-toggle.svg')

export class PhotoSlide extends React.Component<Props, State> {
  setSource(name) {
    // console.log('img: ../../images/' + name)
    try {
      const src = require('../../images/' + name)
      return src
    } catch (err) {
      return require('./img/_dummy.jpg')
      // Do whatever you want when the image failed to load here
    }
  }

  render() {
    if (
      !this.props.captionOpen &&
      this.props.isSliding &&
      this.props.captionWasOpen
    ) {
      this.toggleClass = 'hide'
    } else if (!this.props.captionOpen) {
      this.toggleClass = 'show'
    } else if (this.props.captionOpen) {
      this.toggleClass = 'hide'
    }
    return (
      <>
        <div
          className='section photo-slide'
          id={this.props.slideId}
          style={{
            backgroundImage: `url(${
              this.props.isMobile
                ? this.setSource(this.props.imgMobile)
                : this.setSource(this.props.imgDesktop)
            })`
          }}
        >
          <div
            className='caption'
            style={{ opacity: this.props.captionOpen ? 1 : 0 }}
            onClick={() => {
              this.props.toggleCaption()
            }}
          >
            <div className='bg'>
              <div
                className='closer'
                style={{ backgroundImage: `url(${iconCaption})` }}
              />
            </div>
            <p>{this.props.caption}</p>
            <p className='credits'>{this.props.credits}</p>
          </div>
          <div className='icon-wrapper'>
            <div
              className={`caption-toggle ${this.toggleClass}`}
              // className={`caption-toggle ${this.props.captionOpen ? 'hide' : 'show'}${this.props.isSliding ? ' sliding' : ''}`}
              style={{ backgroundImage: `url(${iconCaption})` }}
              onClick={this.props.toggleCaption}
            >
              <div className='label'>Bildinfo</div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
